import { createInternalHref } from "shared/createInternalHref";
import { SEARCH_PLACEHOLDER, translate } from "shared/translate";
import { SEARCH_TYPE } from "shared/constants";
import { SearchIcon } from "components/Icons";
import { useRouter } from "next/router";
import { VisuallyHiddenText } from "components/VisuallyHiddenText";
import cx from "classnames";
import styles from "./SearchInput.module.css";

export const SearchInput = ({ inBar, query, setQuery }) => {
  const { locale } = useRouter();

  return (
    <form
      action={createInternalHref({
        href: "",
        locale,
        type: SEARCH_TYPE,
      })}
      className={cx(styles.container, { [styles.inBar]: inBar })}
    >
      <VisuallyHiddenText>
        {translate(SEARCH_PLACEHOLDER, locale)}
      </VisuallyHiddenText>
      <input
        autoComplete="off"
        autoFocus
        className={styles.input}
        name="q"
        onChange={(e) => setQuery(e.target.value)}
        placeholder={translate(SEARCH_PLACEHOLDER, locale)}
        type="search"
        value={query}
      />
      <button type="submit" className={styles.button}>
        <SearchIcon />
      </button>
    </form>
  );
};
